// Import dependencies
import React, {Component} from 'react';

// Import css
import './MainButton.css'

// Import components
import { ParagraphText } from '../../global/UXLibrary'


export default class MainButton extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            indicatorAnimation: '',
            lineAnimation: '',
            textColour: '#060812',
            indicatorBlinking: true
        };
        this.expand = this.expand.bind(this);
        this.contract = this.contract.bind(this);
    }

    expand()
    {
        this.setState({
            indicatorAnimation: 'mb__animate-indicator-in',
            lineAnimation: 'mb__animate-line-in',
            textColour: '#ffffff'
        });
    }

    contract()
    {
        this.setState({
            indicatorAnimation: 'mb__animate-indicator-out',
            lineAnimation: 'mb__animate-line-out',
            textColour: '#060812'
        });
    }

    componentDidMount()
    {
        // Remove blinking indicator
        setTimeout(function() { this.setState({ indicatorBlinking: false }) }.bind(this), 2600);
    }

    render()
    {
        return (
            <div
                className='mb__container'
                onMouseEnter={this.expand}
                onMouseLeave={this.contract}
                style={{ cursor: this.props.cursor }}
            >
                <div className='mb__content'>
                    <div className={'mb__line '+this.state.lineAnimation} />
                    <ParagraphText style={{
                        color: this.state.textColour,
                        transition: 'color .7s cubic-bezier(.75,0,.25,1)'
                    }}>
                        { this.props.title }
                    </ParagraphText>
                </div>

                <div className='mb__bg' />
                <div className='mb__bg-temp-overlay' />

                {
                    this.state.indicatorBlinking ?
                        <div className={'mb__indicator-blinking'} />
                        :
                        <div className={'mb__indicator '+this.state.indicatorAnimation} />
                }
            </div>
        );
    }
}
